import React, { useEffect, useState } from 'react';

const PortfolioPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 


  const [activeCase, setActiveCase] = useState(0);

  const cases =[
    {
      title: 'Retail E-commerce Revamp',
      industry: 'Retail',
      image: "/ecommerce.jpg",
      description:
        'We transformed a legacy online store into a high-performance, headless e-commerce experience. The revamp included a lightning-fast storefront, seamless checkout flow, and advanced analytics for tracking customer journeys. Built with a modular architecture, the platform now scales effortlessly across regions, supports personalized product recommendations, and delivers a consistent experience across devices.',
      outcome: ['+32% conversion', '2x faster pages', 'Unified checkout'],
      stack: ['React', 'Node', 'Stripe', 'PostgreSQL']
    },
    {
      title: 'Fintech Mobile Banking',
      industry: 'Finance',
      image: '/Fintech2.jpg',
      description:
        'Developed a next-generation mobile banking app designed for speed, security, and simplicity. Users can open accounts, authenticate via biometrics, make real-time transfers, and track spending insights in one intuitive interface. Our architecture ensured bank-grade encryption, offline access, and a responsive design that adapts seamlessly to any device. The platform achieved 99.9% crash-free sessions and a top-tier app store rating.',
      outcome: ['Biometric auth', 'Realtime transfers', 'Crash-free 99.9%'],
      stack: ['React Native', 'Firebase', 'AWS']
    },
    {
      title: 'Healthcare Portal',
      industry: 'Healthcare',
      image: '/Healthcare2.jpg',
      description:
        'Built a secure and user-friendly healthcare portal enabling patients to connect with doctors remotely, manage appointments, and access medical records digitally. The solution was fully HIPAA-compliant and included encrypted messaging, video consultations, and automated reminders for follow-up care. The portal enhanced patient engagement, reduced wait times, and improved the overall efficiency of medical staff workflows.',
      outcome: ['Telemedicine', 'HIPAA-ready workflows', 'Patient engagement up'],
      stack: ['Vue', 'Python', 'PostgreSQL']
    }
  ];
  

  const gallery = [
    '/gallery1.jpg',
    'https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&q=80',
    'gallery4.jpg'
  ];

  return (
    <main className="pt-20 dark:bg-gray-900 min-h-screen">
      {/* Hero */}
      <section>
        <div className="max-w-7xl mx-auto px-4 py-12 md:py-16">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white">Selected Work</h1>
          <p className="mt-3 md:text-lg text-gray-600 dark:text-gray-300 max-w-3xl">Real outcomes across e‑commerce, fintech, and healthcare—crafted with performance and polish.</p>
        </div>
        <div className="h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </section>

      {/* Case studies switcher */}
      <section className="py-8 bg-blue-50 dark:bg-gray-900 md:py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-wrap gap-3">
            {cases.map((c, i) => (
              <button
                key={i}
                onClick={() => setActiveCase(i)}
                className={`px-4 py-2 rounded-full text-sm font-semibold border transition ${activeCase===i ? 'bg-[#0284c7] text-white border-[#0284c7]' : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700'}`}
              >{c.title}</button>
            ))}
          </div>

          <div className="mt-6 md:mt-8 grid lg:grid-cols-2 gap-8 items-start">
            <div className="rounded-2xl overflow-hidden shadow border border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-800">
              <img src={cases[activeCase].image} alt={cases[activeCase].title} className="w-full h-[364px] object-cover aspect-[4/3]" />
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow border border-gray-200 dark:border-gray-700">
              <div className="text-sm font-semibold text-[#0284c7]">{cases[activeCase].industry}</div>
              <h3 className="mt-1 text-xl md:text-2xl font-bold text-gray-900 dark:text-white">{cases[activeCase].title}</h3>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{cases[activeCase].description}</p>
              <ul className="mt-4 space-y-2 text-sm text-gray-600 dark:text-gray-300">
                {cases[activeCase].outcome.map((o, i) => (
                  <li key={i} className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[#0284c7] rounded-full"></span>{o}</li>
                ))}
              </ul>
              <div className="mt-4 flex flex-wrap gap-2">
                {cases[activeCase].stack.map((t, i) => (
                  <span key={i} className="px-3 py-1 rounded-full bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-xs font-semibold">{t}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

        {/* Section Divider */}
        <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

      {/* Gallery */}
      <section className="pt-8 md:pt-10 bg-gray-100 dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">Gallery</h2>
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {gallery.map((src, i) => (
              <div key={i} className="rounded-xl overflow-hidden bg-gray-200 dark:bg-gray-800">
                <img src={src} alt="Project" className="w-full h-full object-cover aspect-square" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tech */}
      <section className="py-12 bg-gray-100 dark:bg-gray-900 md:py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="rounded-2xl p-6 md:p-10 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white">Technology we love</h3>
            <p className="mt-2 text-gray-700 dark:text-gray-300 text-sm">React, Next.js, Node.js, Python, Postgres, Prisma, Tailwind, AWS, Docker, CI/CD</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PortfolioPage;


